import Cookies from 'js-cookie'

const TokenKey = 'Admin-Token'

export function getToken() {
  // 优先从 localStorage 读取（用于 WKWebView 注入的 token）
  const localToken = localStorage.getItem('token')
  if (localToken) {
    return localToken
  }
  
  // 兜底从 Cookies 读取（用于浏览器环境）
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  // 同时保存到 localStorage 和 Cookies
  localStorage.setItem('token', token)
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  // 同时清除 localStorage 和 Cookies
  localStorage.removeItem('token')
  return Cookies.remove(TokenKey)
}
